// extracted by mini-css-extract-plugin
module.exports = {"button":"GridSquare_button__1aca5"};